/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { routesContext } from "../../../shared/routes/routes-context";
import { overlayModalStyle } from "../../helpers/ui-helper";
import Navigate from "../../../shared/navigation/navigate";
import { showToast } from "../../helpers/show-toast";
class PostedScoreModal extends Component {
  componentDidMount = () => Modal.setAppElement(this.props.appElementName);
  static contextType = routesContext;

  render() {
    const { isOpen } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        style={overlayModalStyle}
        className="challenge-modal-dialog"
        contentLabel="Join Challenge Modal"
      >
        <div className="challenge-modal-content">
          <button
            className="challenge-modal_close"
            onClick={this.props.onCloseModal}
            aria-label="Close"
          >
            ✕
          </button>
          <div className="challenge-modal-body">
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "600",
                textAlign: "center",
                color: "#465476",
                marginBottom: "10px",
                textTransform: "uppercase",
              }}
            >
              {this.props.name}
            </h4>
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              {this.props.title}
            </h3>
            <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "2px" }}>
              <div
                style={{
                  width: "33.3%",
                  height: "10px",
                  backgroundColor: this.props.progress >= 1 ? "#00365F" : "#E0E0E0",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                  backgroundClip: "content-box", // Ensures neat corners
                }}
              ></div>

              <div
                style={{
                  width: "33.3%",
                  height: "10px",
                  backgroundColor: this.props.progress >= 2 ? "#00365F" : "#E0E0E0",
                  borderRadius: "0px",
                }}
              ></div>

              <div
                style={{
                  width: "33.3%",
                  height: "10px",
                  backgroundColor: this.props.progress >= 3 ? "#00365F" : "#E0E0E0",
                  borderTopRightRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              ></div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <div
                className="outer-circle-lighter"
                style={{
                  width: "80px",
                  height: "80px",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#00365F",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#FFF",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", color: "#FFF" }}>
                    <div style={{ fontSize: "13px", margin: "0 auto" }}>NET</div>
                    <div style={{ fontSize: "32px" }}>{this.props.score.net_to_par}</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "700",
                marginBottom: "20px",
                alignItems: "center",
                color: "#465476",
              }}
            >
              <div>
                <div>ADJ. GROSS SCORE</div>
                <div style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#000"
                }}>{this.props.score.adjusted_gross_score}</div>
              </div>
              <div>
                <div>COURSE HANDICAP</div>
                <div style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#000"
                }}>{this.props.score.course_handicap}</div>
              </div>
              <div>
                <div>NET SCORE</div>
                <div style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#000"
                }}>{`${this.props.score.net_score} (${this.props.score.net_to_par})`}</div>
              </div>
            </div>
            <div
              style={{
                marginLeft: "-40px",
                marginRight: "-40px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginBottom: "20px",
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr style={{ borderBottom: "1px solid #E0E0E0" }}>
                    <th style={{ padding: "10px" }}></th>
                    <th style={{ padding: "10px" }}></th>
                    <th style={{ padding: "10px" }}>R1</th>
                    <th style={{ padding: "10px" }}>R2</th>
                    <th style={{ padding: "10px" }}>R3</th>
                    <th style={{ padding: "10px" }}>TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ backgroundColor: "#00365F0D", fontSize: "18px", fontWeight: "500"}}>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px", borderRight: "1px solid #E0E0E0" }}>{this.props.golferName}</td>
                    <td style={{ padding: "10px", borderRight: "1px solid #E0E0E0" }}>{this.props.scores[0] ? this.props.scores[0].net_to_par : ""}</td>
                    <td style={{ padding: "10px", borderRight: "1px solid #E0E0E0" }}>{this.props.scores[1] ? this.props.scores[1].net_to_par : ""}</td>
                    <td style={{ padding: "10px", borderRight: "1px solid #E0E0E0" }}>{this.props.scores[2] ? this.props.scores[2].net_to_par : ""}</td>
                    <td style={{ padding: "10px" }}>{this.props.totalNet}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p
              style={{
                fontWeight: "400",
                fontSize: "18px",
                textAlign: "center",
                marginBottom: "20px",
                color: "#475467",
              }}
            >
              {this.props.content}
            </p>
            <div className="actions centered" style={{ marginTop: "20px" }}>
              <button
                className="btn fill blue"
                onClick={() => Navigate.toPath("/challenges/" + this.props.challengeId)}
                style={{
                  width: "100%",
                  maxWidth: "70%",
                  padding: "10px",
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                VIEW LEADERBOARD
              </button>
              <button
                className="btn outline blue"
                onClick={this.props.onCloseModal}
                style={{
                  borderRadius: "100px",
                  maxWidth: "70%",
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                BACK TO ROUND SUMMARY
              </button>
              <div className="share-row">
                <div className="usga-share" style={{width: "20px", height: "20px"}}/>
                <button className="lnk white color-focus" 
                  style={{
                    textAlign: "center",
                    fontSize: "16px",
                    color: "#00365F",
                    fontWeight: "700",
                    background: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(window.location.origin + `/challenges/${this.props.challengeId}`);
                    showToast("Challenge link copied to clipboard!");
                  }}
                >
                  SHARE CHALLENGE
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

PostedScoreModal.defaultProps = {
  appElementName: "body",
  onCloseModal: () => {},
  onViewLeaderboard: () => {},
  onBackToSummary: () => {},
  onShareChallenge: () => {},
};

PostedScoreModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func,
  onViewLeaderboard: PropTypes.func,
  onBackToSummary: PropTypes.func,
  onShareChallenge: PropTypes.func,
};

export default PostedScoreModal;
